import React from 'react';
import clsx from 'clsx';
import { ReactComponent as ChevronDownBlackIcon } from 'common-assets/assets/icons/chevron-down-black.svg';

import useStyles from './CollapseButton.style';

export interface CollapseButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  children: React.ReactNode;
  expanded: boolean;
  as?: 'button' | 'span';
  className?: string;
  testId?: string;
  autoTestId?: string;
  size?: 'medium'
  variant?: 'underline';
  disableInteractionStyles?: boolean;
}

export const CollapseButton: React.FC<CollapseButtonProps> = ({
  children,
  expanded,
  as = 'button',
  className,
  testId = 'collapse-button',
  autoTestId,
  type = 'button',
  role,
  size,
  'aria-level': ariaLevel,
  variant,
  disableInteractionStyles = false,
  ...props
}) => {
  const c = useStyles({ expanded, size, disableInteractionStyles });
  const headingProps = role === 'heading' ? { role, 'aria-level': ariaLevel } : {};

  return (
    <button
      {...props}
      type={type}
      className={clsx(c.root, className)}
      aria-expanded={expanded}
      data-testid={testId}
      data-autotestid={autoTestId}
    >
      <span {...headingProps} className={variant === 'underline' ? c.underline : ''}>{children}</span>
      <ChevronDownBlackIcon className={c.icon} aria-hidden="true" focusable="false" />
    </button>
  );
};
